/**
 * Controller Class for vdUpsellPrimary
 */
export default class VdUpsellPrimaryController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-upsell-primary')
  }
}
